import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=0cb3979b&scoped=true&"
import script from "./contact.ts?vue&type=script&lang=ts&"
export * from "./contact.ts?vue&type=script&lang=ts&"
import style0 from "./contact.styl?vue&type=style&index=0&id=0cb3979b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb3979b",
  null
  
)

export default component.exports